// Count up ([data-count-up], a figure such as "200+", "90 %" or "4,8"): the number counts up from zero when the
// figure scrolls into view; whatever stands around it ("+", " %") stays. The running number sits in a box as wide
// as the final figure, so nothing beside it moves; screen readers get the final figure at once, and the plain text
// is put back when it is done. Skipped with reduced motion.
import { onceVisible, reducedMotion } from './motion.js'

const DURATION = 1600 // ms

export function initCountUp() {
	if (reducedMotion.matches) return
	const figures = [...document.querySelectorAll('[data-count-up]')].filter((el) => !el.children.length && /\d/.test(el.textContent))
	onceVisible(figures, countUp, '0px 0px -10% 0px')
}

function countUp(el) {
	const text = el.textContent
	// German figures: "." groups thousands, "," starts the decimals
	const match = text.match(/(\d[\d.]*)(,\d+)?/)
	const value = parseFloat(match[1].replace(/\./g, '') + (match[2] ? '.' + match[2].slice(1) : ''))
	const decimals = match[2] ? match[2].length - 1 : 0
	const grouping = match[1].includes('.')
	const before = text.slice(0, match.index)
	const after = text.slice(match.index + match[0].length)
	const format = (n) =>
		before + n.toLocaleString('de-DE', { minimumFractionDigits: decimals, maximumFractionDigits: decimals, useGrouping: grouping }) + after

	const hidden = document.createElement('span')
	hidden.className = 'visually-hidden'
	hidden.textContent = text
	const shown = document.createElement('span')
	shown.className = 'count-up'
	shown.setAttribute('aria-hidden', 'true')
	shown.textContent = text
	el.replaceChildren(hidden, shown)
	shown.style.minInlineSize = `${shown.getBoundingClientRect().width}px`

	let start = 0
	const step = (now) => {
		start ||= now
		const t = Math.min(1, (now - start) / DURATION)
		const eased = t === 1 ? 1 : 1 - 2 ** (-10 * t)
		shown.textContent = format(value * eased)
		if (t < 1) requestAnimationFrame(step)
		else el.textContent = text
	}
	shown.textContent = format(0)
	requestAnimationFrame(step)
}
